/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Plus12({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="12"
      role="img"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 6.75V11h1.5V6.75H11v-1.5H6.75V1h-1.5v4.25H1v1.5h4.25Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
